import React from 'react';
import { Route } from 'react-router';
import Layout from './components/Layout';
import Home1 from './components/Home';


export default () => (
  <Layout>
    <Route exact path='/' component={Home1} />
    
  </Layout>
);



// WEBPACK FOOTER //
// ./src/App.js